type Props = { className?: string };

export function GoogleIcon({ className }: Props) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <title>Google</title>
      <path
        fill="#4285F4"
        d="M23.49 12.27c0-.79-.07-1.55-.2-2.27H12v4.51h6.45c-.28 1.5-1.14 2.78-2.43 3.62v3h3.92c2.29-2.12 3.55-5.22 3.55-8.86z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.96-1.08 7.94-2.92l-3.92-3c-1.08.72-2.46 1.16-4.02 1.16-3.09 0-5.71-2.09-6.65-4.9H1.29v3.08C3.26 21.34 7.31 24 12 24z"
      />
      <path
        fill="#FBBC05"
        d="M5.35 14.34A7.21 7.21 0 0 1 4.96 12c0-.82.14-1.61.39-2.34V6.58H1.29A12 12 0 0 0 0 12c0 1.94.46 3.77 1.29 5.42l4.06-3.08z"
      />
      <path
        fill="#EA4335"
        d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.45-3.45C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.66 1.29 6.58l4.06 3.08C6.29 6.84 8.91 4.75 12 4.75z"
      />
    </svg>
  );
}
